import React from 'react';
import Helmet from 'react-helmet';
import { injectIntl } from 'gatsby-plugin-intl';
import ogImage from '../images/og-img.jpg';

const SEO = ({ intl, title }) => {
    return (
        <Helmet
            htmlAttributes={{ lang: `${intl.formatMessage({ id: 'lang' })}` }}
            title={title}
            meta={[
                {
                    name: `viewport`,
                    content: `width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=0, viewport-fit=cover`,
                },
                {
                    name: `description`,
                    content: `${intl.formatMessage({ id: 'description' })}`,
                },
                {
                    property: `og:title`,
                    content: `${intl.formatMessage({ id: 'title' })}`,
                },
                {
                    property: `og:description`,
                    content: `${intl.formatMessage({ id: 'description' })}`,
                },
                {
                    property: `og:image`,
                    content: `${ogImage}`,
                },
                {
                    property: `author`,
                    content: `${intl.formatMessage({ id: 'author' })}`,
                },
                {
                    property: `og:type`,
                    content: `website`,
                }
            ]}
        />
    );
};

export default injectIntl(SEO);
